module.exports = __webpack_public_path__ + "media/minus.7983c4f7.svg";